export const environment = {
    version: require('../../package.json').version + '-dev',
    production: false
};
